import { Types } from "../actions/EwoActions";

const initialState = {
    rootCauseFamilies: [],
    rootCauseFamilyOptions: [],
    operatorFiveWsOneHAnalysis: [],
    ewoFormCreateWithFile: {},
    ewoFormCreateWithOperatorFields: {},
    ewoForms: {},
    ewoFormDetailById: {},
    checkHasEwoFormObject: {},
    ewoFormOperatorFields: {},
    zipFile: null
};

export const ewoReducer = (state = initialState, action) => {
    switch (action.type) {
        case Types.SET_ROOT_CAUSE_FAMILIES:
            return {
                ...state,
                rootCauseFamilies: action.payload || [],
            };
        case Types.SET_ROOT_CAUSE_FAMILY_OPTIONS:
            return {
                ...state,
                rootCauseFamilyOptions: action.payload || [],
            };
        case Types.SET_OPERATOR_FIVEWS_ONEH_ANALYSIS:
            return {
                ...state,
                operatorFiveWsOneHAnalysis: action.payload || [],
            };
        case Types.SET_EWO_FORM_CREATE_WITH_FILE:
            return {
                ...state,
                ewoFormCreateWithFile: action.payload,
            };
        case Types.SET_CHECK_TASK_HAS_EWO_FORM:
            return {
                ...state,
                checkHasEwoFormObject: action.payload,
            };
        case Types.SET_EWO_FORM_CREATE_WITH_OPERATOR_FIELDS:
            return {
                ...state,
                ewoFormCreateWithOperatorFields: action.payload,
            };
        case Types.SET_EWO_FORMS_LIST:
            return {
                ...state,
                ewoForms: action.payload,
            };
        case Types.SET_EWO_FORM_DETAIL_BY_ID:
            return {
                ...state,
                ewoFormDetailById: action.payload,
                zipFile: action.payload.zipFile || null
            };
        case Types.SET_OPERATOR_FIELDS_BY_TASK_ID:
            return {
                ...state,
                ewoFormOperatorFields: action.payload,
            };
        default:
            return state;
    }
};
